// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-spinner {
  align-items: center;
  justify-content: center;
}

@keyframes spinner-anim {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.bolt-spinner-circle {
  border:  1.5px solid;
  border-color: rgba( 200, 200, 200 ,  1 );
  border-color: rgba( var(--palette-neutral-20,200, 200, 200) ,  1 );
  border-top-color: rgba(0, 90, 158, 1);
  border-top-color: var(--communication-foreground,rgba(0, 90, 158, 1));
  border-radius: 50%;
  animation-name: spinner-anim;
  animation-duration: 1.3s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.53, 0.21, 0.29, 0.67);
}
.bolt-spinner-circle.xsmall {
  width: 0.75rem;
  height: 0.75rem;
}
.bolt-spinner-circle.small {
  width: 1rem;
  height: 1rem;
}
.bolt-spinner-circle.medium {
  width: 1.25rem;
  height: 1.25rem;
}
.bolt-spinner-circle.large {
  width: 1.75rem;
  height: 1.75rem;
}

.bolt-spinner-label {
  color: rgba(0, 90, 158, 1);
  color: var(--communication-foreground,rgba(0, 90, 158, 1));
}

/*# sourceMappingURL=Spinner.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Spinner/Spinner.scss","webpack://./../azure-devops-ui/bin/Components/Spinner/Spinner.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AACA;EACI,mBAAA;EACA,uBAAA;ACAJ;;ADGA;EACI;IACI,uBAAA;ECAN;EDEE;IACI,yBAAA;ECAN;AACF;ADGA;EACI,oBAAA;EACA,wCEGuB;EFFvB,kEAAA;EAEA,qCAAA;EACA,qEAAA;EACA,kBAAA;EACA,4BAAA;ECFF,wBAAwB;EDItB,mCAAA;EACI,+DAAA;ACFR;AACA;EDII,cAAA;EACI,eAAA;ACFR;AACA;EDII,WAAA;EACI,YAAA;ACFR;AACA;EDII,cAAA;EACI,eAAA;ACFR;AACA;EACE,cAAc;EDKhB,eAAA;ACHA;;AAEA;EACE,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA,sCAAsC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
